export enum ReferenceNumberType {
    P40_SALES_ORDER_NUMBER = 'P40 - Sales Order Number',
    P40_PURCHASE_ORDER_NUMBER = 'P40 - Purchase Order Number',
    P41_SALES_ORDER_NUMBER = 'P41 - Sales Order Number',
    P41_PURCHASE_ORDER_NUMBER = 'P41 - Purchase Order Number',
    P41_DELIVERY_NUMBER = 'P41 - Delivery/Shipment Number',
    P24_SALES_ORDER_NUMBER = 'P24 - Sales Order Number',
    P24_PURCHASE_ORDER_NUMBER = 'P24 - Purchase Order Number',
    P24_DELIVERY_NUMBER = 'P24 - Delivery/Shipment  Number',
    P58_SALES_ORDER_NUMBER = 'P58 - Sales Order Number',
    HANDLING_UNIT = 'Handling Unit',
    TRANSPORT_UNIT = 'Transport Unit'
}
